module.exports = __webpack_public_path__ + "img/motion_off.0afb4cfc.svg";